<template>
    <svg role="img">
        <use :xlink:href="'#icon-' + name" />
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        name: {
            type: String,
            default: ''
        },
    }
}
</script>

<style lang="scss" scoped>
svg {
    width: 16px;
    height: 16px;
}
</style>